module.exports = __webpack_public_path__ + "034fad8f0c1e2e687e850b570e25a7ef.MP3";